"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Alignments = exports.Alignments = {
	none: process.env.REACT_APP_Alignments_none,
	center: process.env.REACT_APP_Alignments_center,
	top: process.env.REACT_APP_Alignments_top,
	bottom: process.env.REACT_APP_Alignments_bottom,
	left: process.env.REACT_APP_Alignments_left,
	right: process.env.REACT_APP_Alignments_right
};